import React, {useState, useEffect} from "react";
import {Select} from "antd";
import {useTranslation} from "react-i18next";
//local
import {ButtonTransparent} from "../buttons/ButtonTransparent";
import {ProjectLabel} from "components/ProjectLabel";
import {IconPlus, IconDownOn} from "components/icons";
import cn from "classnames";
import SelectSearchInput from "./SelectSearchInput";

const ProjectsSelect = ({
  list,
  onChange,
  defaultValue,
  onClickAdd,
  selectedValue,
  customIcon,
  noBorder,
  highlightIfNoSelectValue,
  highlightMyProjectsId,
  fullWidth,
  noSelectValue,
  large,
  addClass,
  dropdownRender,
  needSearch = false,
}) => {
  const {t} = useTranslation();
  const {Option} = Select;
  const [filteredProjects, setFilteredProjects] = useState(list);

  const activeProjects = filteredProjects
    .filter((item) => !item.isArchived && item.name)
    .map((project) => (
      <Option key={project.id} value={project.id}>
        <ProjectLabel
          name={project.name}
          code={project.reference}
          fullWidth={fullWidth}
          color={
            highlightMyProjectsId &&
            !!project.Members &&
            !project.Members?.map((member) => member.id).includes(
              highlightMyProjectsId
            ) &&
            "discreteText"
          }
          large={large}
          width="220"
        />
      </Option>
    ));

  const handleSearchResults = (filteredList) => setFilteredProjects(filteredList);

  useEffect(() => {
    setFilteredProjects(list);
  }, [list]);

  return (
    <div
      className={cn(
        "projects-select_wrapper",
        {"no-border": !!noBorder},
        {"__full-width": fullWidth},
        {__large: !!large},
        {[addClass]: !!addClass}
      )}
    >
      <Select
        className="projects-select_select"
        bordered={false}
        onChange={onChange}
        suffixIcon={customIcon ?? <IconDownOn />}
        defaultValue={defaultValue ?? null}
        value={selectedValue}
        placeholder={
          noSelectValue && (
            <ProjectLabel
              name={noSelectValue}
              fullWidth={fullWidth}
              highlight={highlightIfNoSelectValue}
              large={large}
              width="220"
            />
          )
        }
        dropdownRender={
          dropdownRender ??
          ((menu) => (
            <React.Fragment>
              {needSearch && (
                <SelectSearchInput
                  tiny={true}
                  bold={false}
                  uppercase={false}
                  placeholder={t("SEARCH_PROJECTS")}
                  initialList={list.map((project) => ({
                    ...project,
                    label: project.name,
                  }))}
                  fieldSearchBy="label"
                  listResultCallbackAfterSearch={handleSearchResults}
                />
              )}
              {menu}
            </React.Fragment>
          ))
        }
        popupClassName="projects-select_dropdown"
      >
        {activeProjects}
      </Select>
      {onClickAdd && (
        <ButtonTransparent
          icon={<IconPlus />}
          noBorder
          addClass="ml-1 mr-0"
          onClick={onClickAdd}
        />
      )}
    </div>
  );
};

export default ProjectsSelect;
